import { Link, Outlet, useNavigate } from "react-router";
import useUser from "@app/zustand/user";
import { useMemo } from "react";
import { isNativeApp } from "@app/utils/userAgents";
import GooglePlay from "@app/icons/GooglePlay";
import { ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import AppleStore from "@app/icons/AppleStore";

const Welcome = () => {
  const user = useUser((state) => state.user);
  const setUser = useUser((state) => state.setUser);
  const navigate = useNavigate();
  const isLoggedIn = useMemo(() => {
    if (!user) return false;
    if (!user.firstName) return false;
    if (!user.lastName) return false;
    if (!user.etablissement) return false;
    if (!user.status_pro) return false;
    if (!user.specialite) return false;
    if (!user.verifiedAt) return false;
    return true;
  }, [user]);

  return (
    <main className="flex h-full w-full flex-col items-center overflow-auto">
      <section suppressHydrationWarning={true} className="flex h-full w-full flex-col px-4 md:max-w-6xl">
        <div className="mt-4 flex w-full justify-between md:mt-10">
          <h1 className="py-2 text-2xl font-bold text-sky-800">MedSpot.fr 🩺</h1>
          {!!isLoggedIn && (
            <form
              method="POST"
              action="/actions/logout"
              onSubmit={(e) => {
                e.preventDefault();
                fetch(`${import.meta.env.VITE_API_URL}/user/logout`, {
                  method: "POST",
                  credentials: "include",
                });
                setUser(null);
                navigate("/welcome");
              }}
            >
              <button type="submit" className="block text-xs text-sky-800">
                Se déconnecter
              </button>
            </form>
          )}
        </div>
        <span className="mb-10 mt-14 text-3xl text-orange-400 md:max-w-[70%] md:text-6xl">
          Bienvenue sur le réseau social de votre établissement
        </span>
        {!isNativeApp() && (
          <>
            <h2 className="flex justify-start gap-4 text-center text-2xl text-sky-800">
              <ArrowDownCircleIcon className="size-8" />
              Installez l'app
            </h2>
            <div className="my-8 flex items-center gap-4">
              {/* link to apple store and google play */}
              <a href="https://apps.apple.com/app/id6741074853" className="h-14 w-40">
                <AppleStore />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.medspot.v2" className="h-14 w-40">
                <GooglePlay />
              </a>
            </div>
          </>
        )}
        {isLoggedIn ? (
          <Link
            className="mr-auto mt-5 inline-block rounded-lg border border-sky-800 px-10 py-2 text-lg text-sky-800 disabled:cursor-not-allowed disabled:opacity-50"
            to="/"
          >
            x<span className="mr-5">🚑</span>
            Conduisez-moi vers mon fil d'actualité
            <span className="ml-5">{">"}</span>
          </Link>
        ) : (
          <Outlet />
        )}
      </section>
    </main>
  );
};

export default Welcome;
